/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>More information</h4>

<p>Bring up a comprehensive help page.</p>`;

export default function InfoTooltip() {
    return h('div', { innerHTML: body });
}
